import {
	useLaunchParams,
} from '@tma.js/sdk-react'

import type {
	IUseTelegramUserResult,
} from './use-telegram-user.types'

export const useTelegramUser = (): IUseTelegramUserResult => {
	const {
		tgWebAppData,
	} = useLaunchParams()

	if (!tgWebAppData?.user) {
		return {
			user: null,
		}
	}

	return {
		user: tgWebAppData.user,
	}
}
